module.exports = __webpack_public_path__ + "682d986373e1087e3e621766617eea9b.svg";